function setDefaultDates(instance, calendarClient) {
    let defaultDates = false;

    if (instance.element.dataset.defaultdates) {
        defaultDates = JSON.parse(instance.element.dataset.defaultdates);
    }
    const dates = [];
    if (defaultDates !== false) {
        dates[0] = new Date(defaultDates[0]);
        dates[1] = new Date(defaultDates[1]);
        calendarClient.setDate(dates);
    }
}

function setFirstAvailableDates(instance, callbacks) {
    const operative = callbacks.retrieveCachedOperative(instance);
    const flatpickr = instance.calendar.fp;
    const outboundDateFlat = getDateString(flatpickr.selectedDates, 0);
    const returnDateFlat = getDateString(flatpickr.selectedDates, 1);
    if (operative !== undefined || outboundDateFlat === undefined || returnDateFlat === undefined) {
        const { arDatesOut, arDatesRet } = callbacks.getFilteredDates(
            {
                outboundDate: outboundDateFlat,
                returnDate: returnDateFlat
            },
            operative
        );
        if (arDatesOut !== undefined && arDatesOut.length > 0 && arDatesRet !== undefined && arDatesRet.length > 0) {
            const { outboundDate, returnDate } = callbacks.getParsedDates(arDatesOut, arDatesRet);
            instance.calendar.fp.setDate([outboundDate, returnDate]);
            instance.calendar.fp.jumpToDate(Date.now());
        }
    }
}

function getDateString(dates, index) {
    if (dates[index] !== undefined) {
        const timeZoneSubstract = dates[index].getTimezoneOffset() * 60000;
        const correctedDate = new Date(dates[index].getTime() - timeZoneSubstract);
        return correctedDate.toISOString().split('T')[0];
    }
    return undefined;
}

module.exports = {
    setDefaultDates,
    setFirstAvailableDates
};
